import {
  Event,
  ConstructorArgs as EventConstructorArgs,
} from "../../core/Event";
import { EventCategories } from "../../event-categories";
import { EventSubCategories } from "../../event-sub-categories";

export type Data = {
  provider: `apple` | `google`;
};

export type ConstructorArgs = Data & Partial<EventConstructorArgs>;

class OAuthStarted extends Event<Data> {
  public constructor(args: ConstructorArgs) {
    const { provider, ...baseArgs } = args;

    super({
      ...baseArgs,
      category: EventCategories.UI,
      subCategory: EventSubCategories.AUTH,
      type: `OAUTH_STARTED`,
      data: {
        provider,
      },
    });
  }
}

export { OAuthStarted };
